import { render, staticRenderFns } from "./marketProductAdd.vue?vue&type=template&id=0645ba3f&scoped=true"
import script from "./marketProductAdd.vue?vue&type=script&lang=js"
export * from "./marketProductAdd.vue?vue&type=script&lang=js"
import style0 from "./marketProductAdd.vue?vue&type=style&index=0&id=0645ba3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645ba3f",
  null
  
)

export default component.exports